module.exports = __webpack_public_path__ + "a9ba3836be7eba7c5d23587bacc043e9.jpg";